import React, { useState } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { MotionTokenSample as MotionTokenSampleType } from "./designTokensMotionCatalog";
import { TokenViewRow } from "./designTokensViewRows";
import styles from "./DesignTokensMotion.module.scss";

/** Easing samples run over this duration; duration samples use this curve. */
const SAMPLE_EASING_TOKEN = "--ease-out";
const SAMPLE_DURATION_TOKEN = "--duration-slow";

/**
 * A dot that travels along a track with the token applied, once on mount and
 * again on every click. Remounting the dot restarts its animation.
 */
export const MotionTokenSample = ({
    sample,
    tokenName,
}: {
    sample: MotionTokenSampleType;
    tokenName: `--${string}`;
}) => {
    const [replayCount, setReplayCount] = useState(0);
    const easingToken = sample === "easing" ? tokenName : SAMPLE_EASING_TOKEN;
    const durationToken =
        sample === "duration" ? tokenName : SAMPLE_DURATION_TOKEN;

    return (
        <button
            aria-label={`Replay ${tokenName}`}
            className={styles.motionSample}
            onClick={() => setReplayCount((count) => count + 1)}
            type="button"
        >
            <span
                key={replayCount}
                aria-hidden="true"
                className={styles.motionDot}
                style={{
                    animationDuration: `var(${durationToken})`,
                    animationTimingFunction: `var(${easingToken})`,
                }}
            />
        </button>
    );
};

export const DesignTokenUsageCell = React.memo(function DesignTokenUsageCell({
    row,
}: CellContext<ViewTableFeatures, TokenViewRow, unknown>): React.ReactElement {
    return (
        <ViewTableCell className={styles.usage}>
            {row.original.token?.usage}
        </ViewTableCell>
    );
});
